import { useAuthContext } from '../providers/AuthContext';
import { useEffect } from "react";
import { useHistory } from 'react-router-dom';

const Page: React.FC = () => {
  const { logout } = useAuthContext();
  const history = useHistory();

  useEffect(() => {
    logout();
    window.location.href = '/logout';
  }, []);

  return null;
}

export default Page;
